export const getInitialState = () => ({
  type: '',
  specificFields: {
    image: '', // Pix
    code: '' // Pix
  },
  status: 'WAITING_PAYMENT'
});

export const state = getInitialState();
